// eslint-disable-next-line import/no-mutable-exports
var Device = function(agent) {
  this.agent = agent;
}

Device.prototype.isMobile = function() { 
    const mobileRegex = [
      /Android/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
      /webOS/i,
      /IEMobile/i,
      /Opera Mini/i
    ];
    return mobileRegex.some(mobile => this.agent.match(mobile));
}

export default Device;